//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { PaymentSourceDisplayItem } from './PaymentSourceDisplayItem';
import { PaymentSourceRegistrationNextAction } from './Enums';

export class SignupResultItem extends ItemBase {
    FamilyID: string | null = null;
    NextAction: PaymentSourceRegistrationNextAction = PaymentSourceRegistrationNextAction.None;
    ProcessorTransactionID: string | null = null;
    StripeClientSecret: string | null = null;
    Jwt: string | null = null;
    PaymentSource: PaymentSourceDisplayItem | null = null;

    constructor(initializer?: Partial<SignupResultItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "SignupResultItem";
}
